import deliveryMethods from '../mixins/delivery-methods'

export default {
  methods: {
    /**
     * 認証トークンの取得を行う
     * @returns 認証トークン
     */
    getCurrentAuthenticatedUser: async function () {
      try {
        const user = await this.$Amplify.Auth.currentAuthenticatedUser()
        console.log(user)
        const token = user.signInUserSession.idToken.jwtToken
        console.log(token)
        return token
      } catch (e) {
        // 認証情報が無い場合、ログイン画面に戻す
        this.$router.replace('/login')
        throw new Error('Not Authenticated Error')
      }
    },
    /**
     * お知らせ一覧の取得を行う
     * @param {*} queryStringParameters
     * @returns
     */
    requestNotificationListOfUserSite: async function (queryStringParameters) {
      const token = await this.getCurrentAuthenticatedUser()
      let myInit = {
        headers: {
          Authorization: token
        },
        response: true
      }

      if (queryStringParameters) {
        myInit['queryStringParameters'] = queryStringParameters
      }

      var res = null
      try {
        res = await this.$Amplify.API.get(
          deliveryMethods.API_FUNCTION_PHASE2,
          '/api/v1/notifications',
          myInit
        )
      } catch (e) {
        console.log(e)
      }
      console.log('Notification List : ', res)
      return res
    },
    /**
     * アカウント情報の取得を行う
     * @param {*} userId ユーザーOD
     * @returns
     */
    requestAccountInfoOfUserSite: async function (userId) {
      const token = await this.getCurrentAuthenticatedUser()
      let myInit = {
        headers: {
          Authorization: token
        },
        response: true
      }

      var res = null
      try {
        res = await this.$Amplify.API.get(
          deliveryMethods.API_FUNCTION_PHASE2,
          '/api/v1/users/' + userId + '',
          myInit
        )
      } catch (e) {
        console.log(e)
      }
      console.log('Account Info : ', res)
      return res
    },
    /**
     * アカウント情報の更新を行う
     * @param {*} userId ユーザーID
     * @param {*} body Body
     * @returns
     */
    requestUpdateAccountInfo: async function (userId, body) {
      const token = await this.getCurrentAuthenticatedUser()
      let myInit = {
        headers: {
          Authorization: token
        },
        body: body,
        response: true
      }

      var res = null
      try {
        res = await this.$Amplify.API.put(
          deliveryMethods.API_FUNCTION_PHASE2,
          '/api/v1/users/' + userId + '',
          myInit
        )
      } catch (e) {
        console.log(e)
      }
      console.log('Update Account Info : ', res)
      return res
    },
    /**
   * 機種一覧の取得を行う
   * @param {*} queryStringParameters
   * @returns
   */
    requestModelListOfUserSite: async function (queryStringParameters) {
      const token = await this.getCurrentAuthenticatedUser()
      let myInit = {
        headers: {
          Authorization: token
        },
        response: true
      }

      if (queryStringParameters) {
        myInit['queryStringParameters'] = queryStringParameters
      }

      var res = null
      try {
        res = await this.$Amplify.API.get(
          deliveryMethods.API_FUNCTION_PHASE2,
          '/api/v1/machines',
          myInit
        )
      } catch (e) {
        console.log(e)
      }
      console.log('Model List : ', res)
      return res
    },
    /**
     * フォルダ_コンテンツ一覧の取得を行う
     * @param {*} queryStringParameters
     * @returns
     */
    requestContentsListOfUserSite: async function (queryStringParameters) {
      const token = await this.getCurrentAuthenticatedUser()
      let myInit = {
        headers: {
          Authorization: token
        },
        response: true
      }

      if (queryStringParameters) {
        myInit['queryStringParameters'] = queryStringParameters
      }

      console.log('param: ', myInit)

      var res = null
      try {
        res = await this.$Amplify.API.get(
          deliveryMethods.API_FUNCTION_PHASE2,
          '/api/v1/contents',
          myInit
        )
      } catch (e) {
        console.log(e)
      }
      console.log('Contents List : ', res)
      return res
    },
    /**
     * 閲覧用コンテンツを取得
     * @param {*} contentsId コンテンツID
     * @param {*} queryStringParameters
     * @returns
     */
    requestBrowsingContentsOfUserSite: async function (contentsId, queryStringParameters) {
      const token = await this.getCurrentAuthenticatedUser()
      let myInit = {
        headers: {
          Authorization: token
        },
        response: true
      }

      if (queryStringParameters) {
        myInit['queryStringParameters'] = queryStringParameters
      }

      console.log('param: ', myInit)

      var res = null
      try {
        res = await this.$Amplify.API.get(
          deliveryMethods.API_FUNCTION_PHASE2,
          '/api/v1/contents/' + contentsId + '',
          myInit
        )
      } catch (e) {
        console.log(e)
      }
      console.log('Browsing Contents : ', res)
      return res
    },
    /**
     * フォルダダウンロードを行う
     * @param {*} folderId フォルダID
     * @param {*} body
     * @returns
     */
    requestFolderDownloadOfUserSite: async function (folderId, body) {
      const token = await this.getCurrentAuthenticatedUser()
      let myInit = {
        headers: {
          Authorization: token
        },
        body: body,
        response: true
      }

      console.log('param: ', myInit)

      var res = null
      try {
        res = await this.$Amplify.API.post(
          deliveryMethods.API_FUNCTION_PHASE2,
          '/api/v1/folders/' + folderId + '',
          myInit
        )
      } catch (e) {
        console.log(e)
      }
      console.log('Folder Download : ', res)
      return res
    },
    /**
     * コンテンツダウンロードを行う
     * @param {*} contentsIs コンテンツID
     * @param {*} queryStringParameters
     * @returns
     */
    requestContentsDownloadOfUserSite: async function (contentsId, body) {
      const token = await this.getCurrentAuthenticatedUser()
      let myInit = {
        headers: {
          Authorization: token
        },
        body: body,
        response: true
      }

      console.log('param: ', myInit)

      var res = null
      try {
        res = await this.$Amplify.API.post(
          deliveryMethods.API_FUNCTION_PHASE2,
          '/api/v1/contents/' + contentsId + '',
          myInit
        )
      } catch (e) {
        console.log(e)
      }
      console.log('Contents Download : ', res)
      return res
    },
    /**
     * 点検依頼の送信を行う
     * @param {*} body
     * @returns
     */
    requestSendInspectionOfUserSite: async function (body) {
      const token = await this.getCurrentAuthenticatedUser()
      let myInit = {
        headers: {
          Authorization: token
        },
        body: body,
        response: true
      }

      console.log('param: ', myInit)

      var res = null
      try {
        res = await this.$Amplify.API.post(
          deliveryMethods.API_FUNCTION_PHASE2,
          '/api/v1/send/inspection',
          myInit
        )
      } catch (e) {
        console.log(e)
      }
      console.log('Send Inspection : ', res)
      return res
    },
    /**
     *  問い合わせ送信
     * @param {*} body
     * @returns
     */
    requestSendInquiryOfUserSite: async function (body) {
      const token = await this.getCurrentAuthenticatedUser()
      let myInit = {
        headers: {
          Authorization: token
        },
        body: body,
        response: true
      }

      console.log('param: ', myInit)

      var res = null
      try {
        res = await this.$Amplify.API.post(
          deliveryMethods.API_FUNCTION_PHASE2,
          '/api/v1/send/inquiry',
          myInit
        )
      } catch (e) {
        console.log(e)
      }
      console.log('Send Inquiry : ', res)
      return res
    },
    /**
     * プラクティスサポートの送信を行う
     * @param {*} body 
     * @returns 
     */
    requestSendPracticeSupport: async function (body) {
      const token = await this.getCurrentAuthenticatedUser()
      let myInit = {
        headers: {
          Authorization: token
        },
        body: body,
        response: true
      }

      console.log('param: ', myInit)

      var res = null
      try {
        res = await this.$Amplify.API.post(
          deliveryMethods.API_FUNCTION_PHASE2,
          '/api/v1/send/practicesupport',
          myInit
        )
      } catch (e) {
        console.log(e)
      }
      console.log('Send Practice Support : ', res)
      return res
    },
    /**
     * 再登録を行う
     * @param {*} body
     * @returns
     */
    requestReregisterOfUserSite: async function (body) {
      let myInit = {
        body: body,
        response: true
      }

      console.log('param: ', myInit)

      var res = null
      try {
        res = await this.$Amplify.API.post(
          deliveryMethods.API_FUNCTION_PHASE2,
          '/api/v1/users/reregister',
          myInit
        )
      } catch (e) {
        console.log(e)
      }
      console.log('Reregister : ', res)
      return res
    },
    /**
     * 利用規約同意要求を行う
     * @param {*} body
     * @returns
     */
    requestAgreeToTermsOfUse: async function (body) {
      const token = await this.getCurrentAuthenticatedUser()
      let myInit = {
        headers: {
          Authorization: token
        },
        body: body,
        response: true
      }

      console.log('param: ', myInit)

      var res = null
      try {
        res = await this.$Amplify.API.post(
          deliveryMethods.API_FUNCTION_PHASE2,
          '/api/v1/confirm/terms',
          myInit
        )
      } catch (e) {
        console.log(e)
      }
      console.log('Agree To Terms Of Use : ', res)
      return res
    },
    /**
     * チュートリアル確認要求を行う
     * @param {*} body
     * @returns
     */
    requestCheckTutorial: async function (body) {
      const token = await this.getCurrentAuthenticatedUser()
      let myInit = {
        headers: {
          Authorization: token
        },
        body: body,
        response: true
      }

      console.log('param: ', myInit)

      var res = null
      try {
        res = await this.$Amplify.API.post(
          deliveryMethods.API_FUNCTION_PHASE2,
          '/api/v1/confirm/tutorial',
          myInit
        )
      } catch (e) {
        console.log(e)
      }
      console.log('Check Tutorial : ', res)
      return res
    },
    /**
     * リンク取得を行う
     * @param {*} queryStringParameters
     * @returns
     */
    requestLinkListOfUserSite: async function (queryStringParameters) {
      const token = await this.getCurrentAuthenticatedUser()
      let myInit = {
        headers: {
          Authorization: token
        },
        response: true
      }

      if (queryStringParameters) {
        myInit['queryStringParameters'] = queryStringParameters
      }

      var res = null
      try {
        res = await this.$Amplify.API.get(
          deliveryMethods.API_FUNCTION_PHASE2,
          '/api/v1/links',
          myInit
        )
      } catch (e) {
        console.log(e)
      }
      console.log('Link List : ', res)
      return res
    },
    /**
     * お知らせ閲覧履歴登録を行う
     * @param {*} body
     * @returns
     */
    requestInformationBrowsingHistoryRegistrationOfUserSIte: async function (body) {
      const token = await this.getCurrentAuthenticatedUser()
      let myInit = {
        headers: {
          Authorization: token
        },
        body: body,
        response: true
      }

      var res = null
      try {
        res = await this.$Amplify.API.post(
          deliveryMethods.API_FUNCTION_PHASE2,
          '/api/v1/history/notifications',
          myInit
        )
      } catch (e) {
        console.log(e)
      }
      console.log('Information Browsing History Registration : ', res)
      return res
    },
    /**
     * アクセス履歴登録を行う
     * @param {*} body
     * @returns
     */
    requestAccessHistoryRegistrationOfUserSIte: async function (body) {
      const token = await this.getCurrentAuthenticatedUser()
      let myInit = {
        headers: {
          Authorization: token
        },
        body: body,
        response: true
      }

      var res = null
      try {
        res = await this.$Amplify.API.post(
          deliveryMethods.API_FUNCTION_PHASE2,
          '/api/v1/history/users',
          myInit
        )
      } catch (e) {
        console.log(e)
      }
      console.log('Access History Registration : ', res)
      return res
    },
    /**
     * トークン発行要求
     * @param {*} body
     * @returns
     */
    requestTokenIssue: async function (body) {
      let myInit = {
        body: body,
        response: true
      }

      var res = null
      try {
        res = await this.$Amplify.API.post(
          deliveryMethods.API_FUNCTION_PHASE2,
          '/api/v1/users/token',
          myInit
        )
      } catch (e) {
        console.log(e)
      }
      console.log('Token Issue : ', res)
      return res
    },
    /**
     * トークン取得要求
     * @param {*} body
     * @returns
     */
    requestGetToken: async function (queryStringParameters) {
      let myInit = {
        response: true
      }

      if (queryStringParameters) {
        myInit['queryStringParameters'] = queryStringParameters
      }

      var res = null
      try {
        res = await this.$Amplify.API.get(
          deliveryMethods.API_FUNCTION_PHASE2,
          '/api/v1/users/token',
          myInit
        )
      } catch (e) {
        console.log(e)
      }
      console.log('Get Token : ', res)
      return res
    },
    /**
     * J-learning一覧の取得を行う
     * @param {*} queryStringParameters 
     * @returns 
     */
    requestGetJLearningList: async function (queryStringParameters) {
      const token = await this.getCurrentAuthenticatedUser()
      let myInit = {
        headers: {
          Authorization: token
        },
        response: true
      }

      if (queryStringParameters) {
        myInit['queryStringParameters'] = queryStringParameters
      }

      console.log('param: ', myInit)

      var res = null
      try {
        res = await this.$Amplify.API.get(
          deliveryMethods.API_FUNCTION_PHASE2,
          '/api/v1/jlearning',
          myInit
        )
      } catch (e) {
        console.log(e)
      }
      console.log('Get J-learning List : ', res)                      
      return res      
    },
    /**
     * サービスレポート一覧の取得を行う
     * @param {*} queryStringParameters 
     * @returns 
     */
    requestGetServiceReportList: async function (queryStringParameters) {
      const token = await this.getCurrentAuthenticatedUser()
      let myInit = {
        headers: {
          Authorization: token
        },
        response: true
      }

      if (queryStringParameters) {
        myInit['queryStringParameters'] = queryStringParameters
      }

      console.log('param: ', myInit)

      var res = null
      try {
        res = await this.$Amplify.API.get(
          deliveryMethods.API_FUNCTION_PHASE2,
          '/api/v1/report',
          myInit
        )
      } catch (e) {
        console.log(e)
      }      
      console.log('Get Service report List : ', res)
      return res      
    },

    //#region 商品発注
    /**
     * 機種ごとの商品発注一覧の取得を行う
     * @param {*} queryStringParameters 
     * @returns 
     */
    requestGetOrderProductList: async function (queryStringParameters) {
      const token = await this.getCurrentAuthenticatedUser()
      let myInit = {
        headers: {
          Authorization: token
        },
        response: true
      }

      if (queryStringParameters) {
        myInit['queryStringParameters'] = queryStringParameters
      }

      console.log('param: ', myInit)

      var res = null
      try {
        res = await this.$Amplify.API.get(
          deliveryMethods.API_FUNCTION_PHASE2,
          '/api/v1/machines/products',
          myInit
        )
      } catch (e) {
        console.log(e)
      }      
      console.log('Get Order Product List : ', res)
      return res            
    },    
    /**
     * ユーザーに紐づく請求ユーザー一覧の取得を行う
     * @param {*} queryStringParameters 
     * @returns 
     */
    requestGetBillingUsers: async function (queryStringParameters) {
      const token = await this.getCurrentAuthenticatedUser()
      let myInit = {
        headers: {
          Authorization: token
        },
        response: true
      }

      if (queryStringParameters) {
        myInit['queryStringParameters'] = queryStringParameters
      }

      console.log('param: ', myInit)

      var res = null
      try {
        res = await this.$Amplify.API.get(
          deliveryMethods.API_FUNCTION_PHASE2,
          '/api/v1/billings',
          myInit
        )
      } catch (e) {
        console.log(e)
      }      
      console.log('Get Billing User List : ', res)
      return res            
    },
    /**
     * 得意先のクリニックに紐づく請求先一覧の取得を行う
     * @param {*} queryStringParameters 得意先一覧
     * @returns 
     */
    requestGetBillingList: async function (queryStringParameters) {
      const token = await this.getCurrentAuthenticatedUser()
      let myInit = {
        headers: {
          Authorization: token
        },
        response: true
      }

      if (queryStringParameters) {
        myInit['queryStringParameters'] = queryStringParameters
      }

      console.log('param: ', myInit)

      var res = null
      try {
        res = await this.$Amplify.API.get(
          deliveryMethods.API_FUNCTION_PHASE2,
          '/api/v1/billings',
          myInit
        )
      } catch (e) {
        console.log(e)
      }      
      console.log('Get Billing List : ', res)
      return res            
    },
    /**
     * 特定請求先情報の取得を行う
     * @param {*} id 請求先コード
     * @returns 
     */
    requestGetBilling: async function (id) {
      const token = await this.getCurrentAuthenticatedUser()
      let myInit = {
        headers: {
          Authorization: token
        },
        response: true
      }      

      var res = null
      try {
        res = await this.$Amplify.API.get(
          deliveryMethods.API_FUNCTION_PHASE2,
          '/api/v1/billings/' + id + '',
          myInit
        )
      } catch (e) {
        console.log(e)
      }      
      console.log('Get Billing : ', res)
      return res            
    },
    /**
     * 注文確認の送信を行う
     * @returns 
     */
    requestOrderConfirmation: async function (body) {
      const token = await this.getCurrentAuthenticatedUser()
      let myInit = {
        headers: {
          Authorization: token
        },
        body: body,
        response: true
      }

      console.log('param: ', myInit)

      var res = null
      try {
        res = await this.$Amplify.API.post(
          deliveryMethods.API_FUNCTION_PHASE2,
          '/api/v1/orders/carts',
          myInit
        )
      } catch (e) {
        console.log(e)
      }
      console.log('Send Order Confirmation : ', res)
      return res      
    },
    /**
     * 注文内容取得を行う
     * @param {*} id 
     * @returns 
     */
    requestGetOrderConfirmation: async function (id, queryStringParameters) {
      const token = await this.getCurrentAuthenticatedUser()
      let myInit = {
        headers: {
          Authorization: token
        },
        response: true
      }

      if (queryStringParameters) {
        myInit['queryStringParameters'] = queryStringParameters
      }
    
      console.log('param: ', myInit)

      var res = null
      try {
        res = await this.$Amplify.API.get(
          deliveryMethods.API_FUNCTION_PHASE2,
          '/api/v1/orders/carts/' + id + '',
          myInit
        )
      } catch (e) {
        console.log(e)
      }      
      console.log('Get Order confirmation : ', res)
      return res            
    },
    /**
     * 注文内容の更新を行う
     * @param {*} id 
     * @param {*} body 
     * @returns 
     */
    requestUpdateOrderConfirmation: async function (id, body) {
      const token = await this.getCurrentAuthenticatedUser()
      let myInit = {
        headers: {
          Authorization: token
        },
        body: body,
        response: true
      }

      var res = null
      try {
        res = await this.$Amplify.API.put(
          deliveryMethods.API_FUNCTION_PHASE2,
          '/api/v1/orders/carts/' + id + '',
          myInit
        )
      } catch (e) {
        console.log(e)
      }
      console.log('Update Order confirmation : ', res)
      return res
    },
    /**
     * 注文履歴の取得を行う
     * @param {*} id ユーザーID
     * @param {*} queryStringParameters クエリ
     * @returns 
     */
    requestGetOrderHistory: async function (id, queryStringParameters) {
      const token = await this.getCurrentAuthenticatedUser()
      let myInit = {
        headers: {
          Authorization: token
        },
        response: true
      }

      if (queryStringParameters) {
        myInit['queryStringParameters'] = queryStringParameters
      }

      console.log('param: ', myInit)

      var res = null
      try {
        res = await this.$Amplify.API.get(
          deliveryMethods.API_FUNCTION_PHASE2,
          '/api/v1/orders/' + id + '',
          myInit
        )
      } catch (e) {
        console.log(e)
      }      
      console.log('Get Order history : ', res)
      return res            
    },
    /**
     * 注文申し込みを行う
     * @param {*} id 
     * @param {*} body 
     * @returns 
     */
    requestOrderApplication: async function (id, body) {
      const token = await this.getCurrentAuthenticatedUser()
      let myInit = {
        headers: {
          Authorization: token
        },
        body: body,
        response: true
      }

      console.log('param: ', myInit)

      var res = null
      try {
        res = await this.$Amplify.API.post(
          deliveryMethods.API_FUNCTION_PHASE2,
          '/api/v1/orders/' + id + '',
          myInit
        )
      } catch (e) {
        console.log(e)
      }
      console.log('Send Order application : ', res)
      return res      
    },
    /**
     * 現在カートに入っている注文の削除を行う
     * @param {*} id 
     * @returns 
     */
    requestDeleteOrder: async function(id) {
      const token = await this.getCurrentAuthenticatedUser();
      let myInit = {
        headers: {
          Authorization: token,
        },                
        response: true,
      };

      var res = null;
      try {
        res = await this.$Amplify.API.del(
          deliveryMethods.API_FUNCTION_PHASE2,
          '/api/v1/orders/carts/' + id + '',
          myInit
        );
      } catch (e) {
        console.log(e);
      }
      console.log("Delete Order : ", res);
      return res;
    },
    /**
     * クリニック情報一覧の取得を行う     
     * @returns 
     */
    requestGetClinics: async function (queryStringParameters) {
      const token = await this.getCurrentAuthenticatedUser()
      let myInit = {
        headers: {
          Authorization: token
        },
        response: true
      }      

      if (queryStringParameters) {
        myInit['queryStringParameters'] = queryStringParameters
      }

      console.log('param: ', myInit)

      var res = null
      try {
        res = await this.$Amplify.API.get(
          deliveryMethods.API_FUNCTION_PHASE2,
          '/api/v1/clinic',
          myInit
        )
      } catch (e) {
        console.log(e)
      }      
      console.log('Get Clinic List : ', res)
      return res            
    },
    /**
     * 特定クリニック情報の取得を行う
     * @param {*} code クリニックコード
     * @returns クリニック情報
     */
    requestGetClinic: async function (code) {
      const token = await this.getCurrentAuthenticatedUser()
      let myInit = {
        headers: {
          Authorization: token
        },
        response: true
      }       

      var res = null
      try {
        res = await this.$Amplify.API.get(
          deliveryMethods.API_FUNCTION_PHASE2,
          '/api/v1/clinic/' + code + '',
          myInit
        )
      } catch (e) {
        console.log(e)
      }      
      console.log('Get Clinic : ', res)
      return res                  
    },

    //#endregion

    //#region 決済
    /**
     * クレジットカード決済を行う
     * @param {*} body 
     * @returns 
     */
    requestPayment: async function (body) {
      const token = await this.getCurrentAuthenticatedUser()
      let myInit = {
        headers: {
          Authorization: token
        },
        body: body,
        response: true
      }

      console.log('param: ', myInit)

      var res = null
      try {
        res = await this.$Amplify.API.post(
          deliveryMethods.API_FUNCTION_PHASE2,
          '/api/v1/payment',
          myInit
        )
      } catch (e) {
        console.log(e)
      }
      console.log('Payment By Credit Card : ', res)
      return res
    },
    //#endregion
  }
}



// WEBPACK FOOTER //
// ./src/mixins/ApiUtil.js